import React from "react";
import { Container } from "react-bootstrap";
import "./First.css";
import mainimg from "../../../../Asset/Group-290594.png"

const First = () => {
  return (
    <>
      <section className="first-logistic-section">
        <Container>
          <div className="row first-logistic-row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 first-logistic-col-1">
              <div className="hero-title">
                <div className="hero-dec-text">
                  <h1 className="h1">
                    Transform Your Logistics & Shipping with{" "}
                    <strong>Advanced & Personalized IT Solutions</strong>
                  </h1>
                  <div className="dec-text">
                    <p>
                      Streamline your supply chain with our specialized IT
                      services. We improve operations, lower costs, and boost
                      delivery performance, strengthening your position in
                      global logistics.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 first-logistic-col-2">
                <div className="shopify_image_part">
                    <img src={mainimg} alt="shopify" className="w-100" />
                </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
